<template>
  <div class="appointmentList-view">
    <div class="flex-a-c">
      <el-input type="text" :placeholder="$t('business', 'searchAdministratorName')" v-model="keyword" style="width: 240px" show-word-limit>
      </el-input>
      <el-button class="v-primary ml10" type="primary" @click="getPageManager">{{ $t('business', 'search') }}</el-button>
      <el-button class="v-primary ml10" type="primary" @click="editManager('add')">{{ $t('business', 'addAdministrator') }}</el-button>
      <el-button class="v-primary ml10" type="primary" @click="changeBoss">{{ $t('business', 'changeBoss') }}</el-button>
    </div>
    <commonTable :tableData="tableData" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage" :loading="loading" :total="total">
      <template v-slot:table>
        <el-table-column prop="name" align="center" :label="$t('business', 'name')" />
        <el-table-column prop="departmentName" width="250" align="center" :label="$t('business', 'responsibleDepartment')" />
        <el-table-column prop="state" align="center" :label="$t('business', 'permissions')">
          <template slot-scope="scope">
            <div class="flex-c-c">
              <div class="cblue hover_pointer" @click="checkRouters(scope.row)">
                {{ $t('business', 'clickToView') }}
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="empStatus" align="center" label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.empStatus">
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column prop="state" width="270" align="center" :label="$t('business', 'operation')">
          <template slot-scope="scope"><span style="color: #51cbcd; cursor: pointer;margin-right:10px"
              @click="editManager('edit', scope.row)">
              {{ $t('business', 'edit') }}
            </span>
            <span style="color: #FD634E; cursor: pointer;margin-right:10px" @click="deleteManager(scope.row.empId)">
              {{ $t('business', 'delete') }}
            </span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <!-- 查看所有成员 -->
    <el-dialog class="label_dialog" :title="$t('business', 'viewPermissions')" width="30%" center :visible.sync="checkVisible"
      :modal-append-to-body="false" @closed="checkVisible = false">
      <div class="" v-if="memberData">
        <el-tree :data="treeData" ref="tree" show-checkbox :props="defaultProps" node-key="id"></el-tree>
        <div class="d-flex justify-content-center">
          <el-button class="v-primary ml10" @click="checkVisible = false" type="primary">{{ $t('business', 'confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!--身份验证-->
    <el-dialog class="label_dialog" :title="$t('business', 'identityVerification')" width="360px" center :visible.sync="bossCertificationVisible"
      :modal-append-to-body="false" @closed="bossCertificationVisible = false">
      <el-form :model="certificationForm" ref="loginRef" style="width: 300px;">
        <el-form-item style="margin-top: 20px" id="border-none">
          <div class="phone-input-wrapper">
            <el-select v-model="selectedCountry" size="large" style="width: 80px; margin-right: 10px" @change="onCountryChange" popper-class="country-select-dropdown">
              <el-option 
                v-for="country in countryData" 
                :key="country.code" 
                :label="country.code" 
                :value="country.code"
              >
                <span>{{ country.code }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ country.name }}</span>
              </el-option>
            </el-select>
            <el-input v-model="certificationForm.phone" size="large" style="width: 200px; border: none"
              :placeholder="currentCountry.placeholder" prefix-icon="el-icon-mobile"></el-input>
          </div>
        </el-form-item>
        <el-form-item style="margin-top: 20px" prop="password" id="border-none">
          <div class="flex-a-b-c">
            <el-input type="password" style="position: fixed; bottom: -9999px" />
            <el-input v-model="certificationForm.smsCode" auto-complete="new-accounts" size="large"
              style="width: 160px; border: none;" placeholder="请输入验证码" prefix-icon="el-icon-lock"></el-input>
            <el-button plain type="primary" :disabled="countDown !== 0 ? true : false" size="large"
              @click="getSendCode(certificationForm.phone)">{{
                countDown ? `重新发送(${countDown})` : "获取验证码"
              }}</el-button>
          </div>
        </el-form-item>
        <el-form-item style="margin-top: 30px">
          <el-button plain type="primary" style="width: 48%" size="large"
            @click="bossCertificationVisible = false">{{ $t('business', 'cancel') }}</el-button>
          <el-button type="primary" style="width: 48%" size="large" @click="certificationPhone">{{ $t('business', 'verify') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--员工-->
    <el-dialog class="label_dialog" :title="$t('business', 'employeeList')" width="20%" center :visible.sync="administratorVisible"
      :modal-append-to-body="false" @closed="checkVisible = false">
      <div class="">
        <div class="mb20 d-flex">
          <el-input type="text" :placeholder="$t('business', 'searchEmployeeName')" v-model="administratorKey" style="width: 240px" show-word-limit>
          </el-input>
          <el-button class="v-primary ml10" type="primary" @click="queryNotSelf">{{ $t('business', 'search') }}</el-button>
        </div>
        <div class="d-flex flex-wrap-y member-scroll">
          <div class="d-flex flex-column">
            <el-radio-group v-model="selectEmployee">
              <el-radio v-model="item.userId" class="mr30 mb30" style="margin-left: 0" :label="item.userId" :key="index"
                v-for="(item, index) in employees">{{ item.name }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <p v-if="employees.length == 0">{{ $t('business', 'noEmployees') }}</p>
          <el-button class="v-primary ml10" v-else @click="administratorVisible = false" type="primary">{{ $t('business', 'cancel') }}</el-button>
          <el-button class="v-primary ml10" v-if="employees.length > 0" @click="employeeConfirm"
            type="primary">{{ $t('business', 'confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import commonTable from "@/components/common/commonTable";
import {
  queryPageManager,
  deletedManager,
  changeBoss,
  checkAdminSms,
  queryNotSelf
} from "@/api/companyManage.js";
import api from "@/api/login";
import utils from "@/utils/index";
import userRoot from '@/utils/root'
import { getCountriesData } from "@/utils/i18n/countries";
import { processI18nPermissions } from '@/utils/root';
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "appointmentList",
  components: {
    commonTable,
  },
  mixins: [i18nMixin],
  data() {
    return {
      keyword: '',
      tableData: [],
      total: 0, //总条数
      currentPage: 1, //当前页数
      pageNum: 1,
      pageSize: 10,
      loading: false, //加载中
      checkVisible: false,//新增部门开关
      bossCertificationVisible: false,
      administratorVisible: false,
      administratorKey: "",//员工姓名
      memberData: '',//成员数据
      selectEmployee: '',
      treeData: [],
      employees: [],
      defaultProps: {
        children: 'subs',
        label: 'title'
      },
      countDown: 0,
      certificationForm: {
        phone: '',
        smsCode: ''
      },
      // 国际区号相关数据
      selectedCountry: '+86', // 默认中国区号
    };
  },
  computed: {
    // 动态获取当前语言的国家数据
    countryData() {
      return getCountriesData(this.$store.state.currentLanguage);
    },
    // 当前选中的国家信息
    currentCountry() {
      return this.countryData.find(country => country.code === this.selectedCountry) || this.countryData[0];
    }
  },
  watch: {
    // 监听语言变化，强制更新组件
    currentLanguage() {
      this.$forceUpdate();
      // 如果当前有打开的权限查看对话框，重新处理权限数据
      if (this.checkVisible && this.treeData.length > 0) {
        this.treeData = processI18nPermissions(userRoot.userRoot, this.currentLanguage);
      }
    }
  },
  mounted() {
    this.getPageManager()
  },
  methods: {
    //请求管理员信息
    getPageManager() {
      this.loading = true;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.keyword,
      };
      queryPageManager(data)
        .then((res) => {
          this.loading = false;
          if (this.pageNum == 1) {
            this.tableData = res.data.pageInfo.list || [];
          } else {
            this.tableData = [res.data.pageInfo.list, ...this.tableData];
          }
          this.total = res.data.pageInfo.total;
          this.pageNum ++;
        })
        .catch((err) => {
          this.tableData = [];
          this.loading = false;
          console.log(err);
        });
    },
    //当前页变更
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getPageManager();
    },
    //当前页查询数据条数变更
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getPageManager();
    },
    //查看所有
    checkRouters(row) {
      let than = this
      if (!row.routers) {
        return this.$message({
          message: this.$t('business', 'noPermissionsAssigned'),
          type: "warning",
        });
      }
      
      // 使用processI18nPermissions处理多语言权限数据
      let routers = processI18nPermissions(userRoot.userRoot, this.currentLanguage);
      
      routers.map((item, index) => {
        item.disabled = true
        if (item.subs) {
          item.subs.map((v, k) => {
            v.disabled = true
            if (v.subs) {
              v.subs.map((v1, k1) => {
                v1.disabled = true
                if (v1.subs) {
                  v1.subs.map((v2, k2) => {
                    v2.disabled = true
                  })
                }
              })
            }
          })
        }
      })
      this.treeData = routers
      this.memberData = row
      row.routers = JSON.parse(row.routers)
      this.$nextTick(() => {
        than.$refs.tree.setCheckedKeys(row.routers)
      })
      this.checkVisible = true
    },
    //删除管理员
    deleteManager(id) {
      this.$confirm(this.$t('business', 'deleteConfirm'), this.$t('business', 'tip'), {
        confirmButtonText: this.$t('business', 'confirm'),
        cancelButtonText: this.$t('business', 'cancel'),
        type: "info ",
      })
        .then(() => {
          let data = {
            empId: id
          }
          deletedManager(data)
            .then(res => {
              this.$message({
                message: this.$t('business', 'deleteSuccess'),
                type: "success",
              });
              this.pageNum = 1;
              this.currentPage = 1;
              this.getPageManager()
            })
        })
        .catch((err) => { });
    },
    //编辑成员
    editManager(type, item) {
      if (type == 'add') {
        this.$router.push({ path: 'AdministratorDetail' })
      } else {
        let id = item.empId
        this.$router.push({ path: '/AdministratorDetail?id=' + id })
      }
    },
    //更换boss
    changeBoss() {
      this.$confirm(this.$t('business', 'changeBossConfirm'), this.$t('business', 'tip'), {
        confirmButtonText: this.$t('business', 'confirm'),
        cancelButtonText: this.$t('business', 'cancel'),
        type: "info ",
      }).then(() => {
        this.bossCertificationVisible = true;
      })
        .catch((err) => { });
    },
    // 国家区号改变
    onCountryChange() {
      this.certificationForm.phone = '';
    },
    //验证boss手机号
    certificationPhone() {
      // 构建包含区号的完整手机号
      const fullPhone = this.selectedCountry + this.certificationForm.phone;
      const data = {
        phone: fullPhone,
        smsCode: this.certificationForm.smsCode
      };
      
      checkAdminSms(data)
        .then((res) => {
          //表示认证成功
          if (res && res.code == 200) {
            this.queryNotSelf();
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        });
    },
    queryNotSelf() {
      //查询员工
      queryNotSelf({ xx: false, name: this.administratorKey }).then(data => {
        if (data.code == 200 && data.data) {
          this.employees = data.data;
          this.administratorVisible = true;
        } else {
          this.employees = ''
        }
      });
    },
    //更换boss
    employeeConfirm() {
      if (!this.selectEmployee) {
        this.$message({
          title: this.$t('business', 'tip'),
          message: this.$t('business', 'selectEmployee'),
          type: "warning",
        });
      }
      changeBoss({ userId: this.selectEmployee }).then((res) => {
        //表示认证成功
        if (res && res.code == 200) {
          this.$message({
            title: this.$t('business', 'tip'),
            message: this.$t('business', 'changeSuccess'),
            type: "warning",
          });
          this.administratorVisible = false;
          utils.clearLoginInfo()
        }
      })
        .catch((err) => {
        });
    },
    getSendCode(phone) {
      // 使用当前选中国家的手机号验证规则
      const currentCountry = this.currentCountry;
      const phoneRegex = new RegExp(currentCountry.pattern);
      if (!phoneRegex.test(phone)) {
        this.$message({
          title: "警告",
          message: currentCountry.placeholder,
          type: "warning",
        });
        return;
      }
      
      // 构建完整的手机号（包含区号）
      const fullPhone = this.selectedCountry + phone;
      api.fetchCompanyByPhone({ phone: fullPhone }, { showLoading: false }).then((res) => {
        this.countDown = 60;
        this.timer = setInterval(() => {
          this.countDown--;
          if (this.countDown === 0) {
            clearInterval(this.timer);
          }
        }, 1 * 1000);
        this.registerForm.companyId = res.data[0].companyId;
        this.registerForm.companyName = res.data[0].companyName;
      });
      api
        .fetchPhoneVeriCode({ phone: phone, type: 1, countryCode: this.selectedCountry }, { showLoading: false })
        .then((res) => { })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
.member-box {
  padding: 5px 10px;
  background: #51CDCB;
  display: flex;
  justify-content: center;
  align-items: center;
  font: 14px;
  color: #ffffff;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 3px;
}
.more-box {
  padding: 5px 10px;
  background: #FD634E;
  display: flex;
  justify-content: center;
  align-items: center;
  font: 14px;
  color: #ffffff;
  border-radius: 3px;
}
.member-scroll {
  max-height: 300px;
  overflow-y: auto;
}

/* 国际区号下拉选项列表样式 */
:deep(.country-select-dropdown) {
  min-width: 336px !important;
}

:deep(.country-select-dropdown .el-select-dropdown__item) {
  padding: 0 20px;
}

:deep(.country-select-dropdown .el-select-dropdown__item span:last-child) {
  margin-left: 20px;
}
</style>
